import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Where markets and the financial sector are functioning, cash transfers can be an effective path to improve food security and nutrition outcomes. WFP uses cash transfers – in the form of banknotes, e-money, mobile money, debit cards or value vouchers – to empower people with choice to address their essential needs while boosting the local economy.`}</p>
    <p>{`In countries like `}<strong parentName="p">{`Lebanon`}</strong>{`, which hosts the world’s highest number of refugees per capita, EU-funded cash assistance has been a lifeline for families who had to flee their homes due to conflict and insecurity. In 2019, the EU contributed more than €70 million to WFP’s operations in the country, helping vulnerable refugees and host communities make ends meet.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      